<template>
	<div class="new-footer">
		<v-layout 
			wrap 
			class="footer-logo"
			:class="{'gray': gray}">
			<v-flex xs12>
				<v-layout wrap class="container">
					<v-flex>
						<button @click="goToHome">
							<img
								v-if="gray"
								:src="`${$S3}logo-text-green.svg`" 
								alt="logo" 
								class="logo">
							<img
								v-else 
								:src="`${$S3}logo-text.svg`" 
								alt="logo" 
								class="logo">
						</button>
					</v-flex>
					<v-flex class="wrapper-btn">
						<v-layout justify-end wrap>
							<v-flex xs12 md5 mr-4 v-if="!gray">
								<a
									href="#banner"
									class="btn-footer bold">Solicita tu app</a>
							</v-flex>
							<v-flex xs6 md2 class="btn-networks right">
								<a 
									:href="linkFace" 
									class="footer-link link-m-right" 
									target="_blank"
									:class="{'gray': gray}">
									<img 
										:src="`${$S3}facebook-logo.png`" 
										alt="facebook"
										height="25">
								</a>
							</v-flex>
							<v-flex xs6 md2 class="btn-networks left">
								<a 
									:href="linkInst" 
									class="footer-link"
									:class="{'gray': gray}" 
									target="_blank">
									<img 
										:src="`${$S3}instagram-logo.png`" 
										alt="instagram"
										height="25">
								</a>
							</v-flex>
						</v-layout>
					</v-flex>
				</v-layout>
			</v-flex>
		</v-layout>
		<v-layout wrap class="wrapper-information container">
			<v-flex xs12 md5>
				<v-layout wrap>
					<v-flex xs12 :class="[isPeru ? 'order-1' : 'order-2']">
						<div class="mb-5">
							<p class="title bold">Perú</p>
							<a 
								class="bold link-direction mb-2" 
								href="https://goo.gl/maps/8vAGxHq1v49WAxj26" 
								target="_back">Lima</a>
							<p>{{ phonePer }}<br/>Calle Independencia  106, Piso 10 <br/>Miraflores</p>
						</div>
					</v-flex>
					<v-flex xs12 :class="[!isPeru ? 'order-1' : 'order-2']">
						<div>
							<p class="title bold">Ecuador</p>
							<a 
								class="bold link-direction mb-2" 
								href="https://www.google.com/maps/search/Pinta+236+y+R%C3%A1bida.+Edif.+La+Pinta/@-0.1992127,-78.4896696,18z"
								target="_blank">Latacunga</a>
							<p>{{ phoneEcu }}<br/>AV. UNIDAD NACIONAL Y GABRIELA MISTRAL. EDIF. FENIX CORP. <br>
									Matríz Centro Tecnológico Latacunga
							</p>
						</div>
					</v-flex>
				</v-layout>
			</v-flex>
			<v-flex xs12 md3 class="dis-flex">
				<v-layout wrap>
					<v-flex xs12 class="wrapper-text-medium">
						<p class="mb-0">Tenemos un regalo para los primeros {{ numberCoupon }} negocios validados.</p>
					</v-flex>
				</v-layout>
			</v-flex>
			<v-flex xs12 md4>
				<img 
					:src="`${$S3}phone-app-screen-footer-min.png`" 
					alt="imagen celular"
					class="logo-cel"
				>
			</v-flex>
		</v-layout>
	</div>
</template>
<script>

function phonePer() {
	return process.env.PHONE_PER;
}

function phoneEcu() {
	return process.env.PHONE_ECU;
}
function created() {
	this.linkFace = process.env.LINK_FACEBOOK;
	this.linkInst = process.env.LINK_INSTAGRAM;
	this.numberCoupon = process.env.NUMBER_COUPON;
}

function data() {
	return {
		linkFace: '',
		linkInst: '',
		numberCoupon: 0,
	};
}

export default {
	name: 'new-footer',
	data,
	computed: {
		phonePer,
		phoneEcu,
	},
	created,
	props: {
		gray: {
			type: Boolean,
			default: false,
		},
	},
};
</script>
<style lang="scss" scoped>
	.new-footer {
		font-family: font(lato-regular);

		.footer-logo {
			background-color: map-get($colors, back-green);
			padding: 50px 7%;

			&.gray {
				background-color: color(back-gray-l);
			}
		}

		.btn-footer {
			background-color: map-get($colors, title-green);
			border-radius: 9px;
			color: map-get($colors, white);
			display: inline-block;
			font-size: map-get($sizes, medium18);
			text-align: center;
			padding: 13px 0;
			text-decoration: none;
			width: 100%;

			@media (max-width: 936px) {
				display: block;
				margin: auto;
				max-width: 227px;
				width: 100%;
			}
		}

		.footer-link {
			align-items: center;
			background-color: map-get($colors, white);
			border-radius: 50%;
			display: flex;
			height: 54px;
			justify-content: center;
			text-align: center;
			width: 54px;

			&.gray {
				background-color: color(green-link);
			}
		}

		.wrapper-btn {
			align-self: center;
		}

		.wrapper-information {
			color: map-get($colors, title-green);
			padding: 40px 7% 0 7%;

			@media (min-width: 1350px) {
				padding: 40px 0 0 0;
			}
		}

		.title {
			font-size: map-get($sizes, large);
		}

		.link-direction {
			color: map-get($colors, title-green);
			display: inline-block;
			text-decoration: none;
		}
		
		.wrapper-end {
			background: map-get($colors, title-green);
			color: map-get($colors, white);
			padding: 14px;
			text-align: center;
		}

		.link {
			color: map-get($colors, white);
			text-decoration: none;
		}

		.logo {
			height: 89px;

			@media (max-width: 936px) {
				height: auto;
				width: 100%;
			}
		}

		.logo-cel {
			height: 312px;

			@media (max-width: 936px) {
				height: auto;
				width: 100%;
			}
		}

		.btn-networks {
			@media (max-width: 936px) {
				margin-top: 50px;
			}

			&.right {
				@media (max-width: 936px) {
					text-align: right;
					padding-right: 14px;
				}
			}

			&.left {
				@media (max-width: 936px) {
					padding-left: 14px;
				}
			}
		}

		.link-m-right {
			@media (max-width: 936px) {
				margin-left: auto;
			}
		}

		.order-1 {
			order: 1;
		}

		.order-2 {
			order: 2;
		}
	}

	.wrapper-text-medium {
    align-items: center;
    display: flex;
		padding: 0 20px;

		p {
			color: color(green-dark);
			font-size: size(large);
			font-weight: 600;
		}
	}

	.dis-flex {
		display: flex;
	}
</style>


// WEBPACK FOOTER //
// src/components/home/new-footer.vue